/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Limits_BodyInputs */

const en_svc_n8n_limits_body = /** @type {(inputs: Svc_N8n_Limits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation that breaks quietly costs more than the manual work it replaced.`)
};

const lv_svc_n8n_limits_body = /** @type {(inputs: Svc_N8n_Limits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatizācija, kas klusi salūzt, izmaksā vairāk nekā roku darbs, ko tā aizstāja.`)
};

/**
* | output |
* | --- |
* | "Automation that breaks quietly costs more than the manual work it replaced." |
*
* @param {Svc_N8n_Limits_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_limits_body = /** @type {((inputs?: Svc_N8n_Limits_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Limits_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_limits_body(inputs)
	return en_svc_n8n_limits_body(inputs)
});